/**
 * Persist a resize percentage (column split / drawer width) to localStorage so a
 * user's drag survives reopening the panel. Keyed per resizable surface.
 */
export const readStoredPct = (key: string, fallback: number): number => {
	const raw = localStorage.getItem(key);
	if (raw === null) return fallback;
	const parsed = Number(raw);
	return Number.isFinite(parsed) ? parsed : fallback;
};

export const writeStoredPct = (key: string, value: number): void => {
	localStorage.setItem(key, String(value));
};
